import { z } from 'zod';

export const postEmailBackofficeSchema = z.object({
  toUserId: z.string(),
  subject: z.string(),
  message: z.string(),
});

const BugReportQuestionSchema = z.object({
  question: z.string(),
  answer: z.string(),
});

export const CreateBugReportRequestBodySchema = z.object({
  questions: z.array(BugReportQuestionSchema),
  message: z.string(),
  media_urls: z.array(z.string()),
  debugInfo: z.record(z.string(), z.unknown()),
});

export const putTrainerWorkoutTemplateIndicesSchema = z.object({
  indices: z.record(z.string(), z.number().int().gte(0)),
});
